export default __webpack_public_path__ + "static/media/NextIcon.dd91e46f.svg";